/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Filters_LabelInputs */

const en_us2_search_filters_label = /** @type {(inputs: Search_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by muscle`)
};

const pt_br2_search_filters_label = /** @type {(inputs: Search_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por músculo`)
};

const es_419_search_filters_label = /** @type {(inputs: Search_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por músculo`)
};

const pt_pt2_search_filters_label = /** @type {(inputs: Search_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por músculo`)
};

const fr_fr2_search_filters_label = /** @type {(inputs: Search_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer par muscle`)
};

const de_de2_search_filters_label = /** @type {(inputs: Search_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Muskel filtern`)
};

const it_it2_search_filters_label = /** @type {(inputs: Search_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtra per muscolo`)
};

/**
* | output |
* | --- |
* | "Filter by muscle" |
*
* @param {Search_Filters_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_filters_label = /** @type {((inputs?: Search_Filters_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Filters_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_filters_label(inputs)
	if (locale === "es-419") return es_419_search_filters_label(inputs)
	if (locale === "pt-PT") return pt_pt2_search_filters_label(inputs)
	if (locale === "fr-FR") return fr_fr2_search_filters_label(inputs)
	if (locale === "de-DE") return de_de2_search_filters_label(inputs)
	if (locale === "it-IT") return it_it2_search_filters_label(inputs)
	return en_us2_search_filters_label(inputs)
});
export { search_filters_label as "search.filters_label" }